import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import Loader from '../../components/Loader';
import BASE_URL from '../../config/config';
import Verificacion from '../../components/Verificacion';
import Suspendido from '../../components/Suspendido';
import { FiClock, FiInbox, FiCheck } from 'react-icons/fi';
import { metaCategoria } from './admin/servicios/categorias';

const Servicios = () => {
    const [servicios, setServicios] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [error, setError] = useState(null);

    const navigate = useNavigate();

    const token = localStorage.getItem('AuthToken');
    const tokenInfo = token ? jwtDecode(token) : {};

    useEffect(() => {
        if (!tokenInfo.usuario) return;

        const obtenerServicios = async () => {
            try {
                const resp = await axios.get(`${BASE_URL}/servicios/usuario/${tokenInfo.usuario}`, {
                    headers: { Authorization: token },
                });
                setServicios(resp.data.servicios || []);
            } catch (err) {
                console.error('Error al obtener los servicios:', err);
                setError('No hemos podido cargar tus servicios. Inténtalo de nuevo en unos minutos.');
            } finally {
                setCargando(false);
            }
        };

        obtenerServicios();
        // eslint-disable-next-line
    }, [tokenInfo.usuario]);

    if (cargando) return <div className="loader-fullscreen"><Loader /></div>;

    if (tokenInfo.estado === 'verificar') return <Verificacion />;
    if (tokenInfo.estado === 'suspendido') return <Suspendido />;

    return (
        <main className="site-width">
            <button className="boton-volver" onClick={() => navigate('/dashboard')}>
                ← Volver
            </button>

            <div className="pagina-cabecera">
                <h2>Mis servicios</h2>
                <p>Estos son los servicios contratados y asociados a tu cuenta.</p>
            </div>

            {error && <p className="error">{error}</p>}

            {!error && servicios.length === 0 && (
                <div className="gn-vacio">
                    <FiInbox />
                    <p>Todavía no tienes servicios asociados a tu cuenta.</p>
                    <button className="gn-boton-cancelar" onClick={() => navigate('/nuevo-ticket')}>
                        Abrir un ticket
                    </button>
                </div>
            )}

            {!error && servicios.length > 0 && (
                <div className="srv-grid">
                    {servicios.map((servicio) => {
                        const { label, icon: Icono } = metaCategoria(servicio.categoria);
                        return (
                            <article key={servicio.id} className={`srv-card srv-card--${servicio.categoria}`}>
                                <div className="srv-card-cabecera">
                                    <span className={`srv-categoria srv-categoria--${servicio.categoria}`}>
                                        <Icono /> {label}
                                    </span>
                                    {servicio.horas !== null && typeof servicio.horas !== 'undefined' && (
                                        <span className="srv-horas"><FiClock /> {servicio.horas} h</span>
                                    )}
                                </div>

                                <h3 className="srv-card-titulo">{servicio.titulo}</h3>

                                {servicio.descripcion?.length > 0 && (
                                    <ul className="srv-card-lista">
                                        {servicio.descripcion.map((punto, i) => (
                                            <li key={i}><FiCheck /> <span>{punto}</span></li>
                                        ))}
                                    </ul>
                                )}
                            </article>
                        );
                    })}
                </div>
            )}
        </main>
    );
};

export default Servicios;
